export enum SchoolYear {
    NINTH = 9,
    TENTH = 10,
    ELEVENTH = 11,
    TWELFTH = 12,
  }